import React from 'react';
import { CTAButton } from './CTAButton';
import { images } from '../data/offer';
export function Creator() {
  return <section className="w-full bg-cream px-4 py-16 sm:py-24" data-id="element-83" data-mp="26ccv6ulee1dp">
      <div className="mx-auto grid max-w-5xl items-start gap-10 lg:grid-cols-[2fr_3fr] lg:gap-14" data-id="element-84" data-mp="2297tgu9563q4">
        <div className="mx-auto w-full max-w-sm lg:sticky lg:top-8" data-id="element-85" data-mp="1xan11h04soc8">
          <img src={images.creator} alt="Dr. Nathan Brooks in a dental clinic" className="w-full rounded-3xl object-cover ring-4 ring-white" loading="lazy" data-id="element-86" data-mp="1xchgwgwjpq9g" />
          <div className="mt-4 text-center" data-id="element-87" data-mp="1ilgvlbapa1vw">
            <p className="font-serif text-2xl font-black text-ink" data-id="element-88" data-mp="1ima4aht7z1go">Dr. Nathan Brooks</p>
            <p className="text-sm font-semibold text-brand" data-id="element-89" data-mp="1ekwyg7q4my9r">Periodontal Education & Creator of Perio Blueprint™</p>
          </div>
        </div>

        <div data-id="element-90" data-mp="19mvdfh954ovn">
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-gum sm:text-sm" data-id="element-91" data-mp="14lpkpjfhd1m4">About the Creator</p>
          <h2 className="mt-3 font-serif text-[32px] font-black leading-tight text-ink sm:text-5xl" data-id="element-92" data-mp="220mwpym59ntk">
            Why I Built Perio Blueprint™
          </h2>
          <div className="mt-6 space-y-4 text-[17px] leading-relaxed text-ink/85" data-id="element-93" data-mp="26seepkr8il83">
            <p data-id="element-94" data-mp="1t0zytmsmj059">For years, I’ve been interested in how dental professionals organize the information they learn.</p>
            <p data-id="element-95" data-mp="1xz1cfs7a679c">
              In Periodontology, we study periodontal anatomy, clinical examination, classification, risk factors,
              treatment concepts, and maintenance. Each subject matters.
            </p>
            <p data-id="element-96" data-mp="2pnmoqnjjfpjv">
              But studying these subjects separately doesn’t always make it easy to see how they connect when we’re
              reviewing a case or preparing a clinical discussion.
            </p>
            <p data-id="element-97" data-mp="10basqv1249ws">That observation inspired me to create Perio Blueprint™.</p>
            <p data-id="element-98" data-mp="10d42wkavpc9j">
              I didn’t want to create another extensive textbook or a course filled with hours of lectures.{' '}
              <strong data-id="element-99" data-mp="l7rh77thlyxo">
                I wanted to build a practical visual reference that brings related concepts together in one organized
                framework.
              </strong>{' '}
              Something you can open, navigate, study, and revisit.
            </p>
            <p data-id="element-100" data-mp="cdcy0u5u649a">
              My intention is not to replace your clinical education, professional experience, or judgment. It’s to give
              you another way to organize the information you already have, identify questions that need further review,
              and prepare more structured educational discussions.
            </p>
            <p data-id="element-101" data-mp="3pn961px1g9tr">
              I hope Perio Blueprint™ becomes a useful part of your professional learning and case-review process.
            </p>
            <p className="font-serif text-xl font-bold italic text-brand-dark" data-id="element-102" data-mp="3kp7kmyc53yf4">— Dr. Nathan Brooks</p>
          </div>

          <div className="mt-10" data-id="element-103" data-mp="1ivrus3nvmnl7">
            <CTAButton label="I Want Dr. Brooks’ Framework" data-id="element-104" data-mp="1iwt86esd7m63" />
          </div>
        </div>
      </div>
    </section>;
}